import React, { useState, useRef, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import { projects } from "../../content/content";
import { FaArrowRight } from "react-icons/fa";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";


const CbgProjects = () => {
  const [activeIndex, setActiveIndex] = useState(0);
   const navigate = useNavigate();
 

  useEffect(() => {
    const elements = document.querySelectorAll(
      ".fade-in, .slide-up, .title-animate, .desc-animate, .card-animation"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.2 }
    );

    elements.forEach((el) => observer.observe(el));

    return () => elements.forEach((el) => observer.unobserve(el));
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="max-w-7xl mx-2 md:mx-auto text-center py-10">
      <p className="text-sm text-gray-500 uppercase fade-in">
        Innovation, Quality And Continuous Improvement
      </p>
      <h2 className="text-2xl md:text-3xl font-bold text-gray-800 font-sans inline-block px-6 py-2 mt-2 title-animate">
        Latest Projects, Solutions And <br /> Energy Supplies
      </h2>

      <div className="mt-8 slide-up">
        <Slider {...settings} afterChange={(index) => setActiveIndex(index)}>
          {projects.map((project) => (
            <div key={project.id} className="px-4 card-animation">
              <div className="bg-white shadow-lg rounded overflow-hidden group transition-all duration-300">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-64 object-cover"
                />
                <div className="p-5 text-left">
                  <p className="text-xs px-2 text-green-500 font-sans">
                    {project.category}
                  </p>
                  <h3 className="text-lg font-bold px-2 font-sans text-gray-800 mt-1">
                    {project.title}
                  </h3>
                  <p className="text-sm font-sans text-gray-600 px-2 mt-2 desc-animate">
                    {project.description}
                  </p>
                  <div className="flex flex-col mx-auto md:mx-2 items-center">
                    {/* <button className="relative mt-4 border-2 border-gray-800 flex items-center justify-between w-full h-10 px-2 text-gray-800 transition-all duration-300 group overflow-hidden"  onClick={() => (navigate("/synergy-dg"))}>
                      <span className="absolute inset-0 bg-white transition-all duration-[600ms] ease-in-out group-hover:w-0"></span>
                      <span className="absolute inset-0 bg-green-400 w-0 transition-all duration-[600ms] ease-in-out group-hover:w-full"></span>
                      <span className="relative z-10">Explore More</span>
                      <FaArrowRight className="relative z-10 transition-all duration-300" />
                    </button> */}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>

        <div className="flex justify-center mt-6 gap-2">
          {projects.map((_, index) => (
            <div
              key={index}
              className={`w-8 h-2 rounded-lg transition-all duration-300 ${
                activeIndex === index ? "bg-green-500" : "bg-gray-500"
              }`}
            ></div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CbgProjects;
